import { Component } from '@angular/core';

@Component({
  selector: 'app-shoping',
  templateUrl: './shoping.component.html',
  styleUrl: './shoping.component.scss'
})
export class ShopingComponent {

}
